import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import GradingStationContainer from './GradingStationContainer';
import GradingStationIndividualPageContainer from './GradingStationIndividualPageContainer';

const GradingStationRoot = ({ currentUser, ziggeoApiKey, canGradeGroups }) => {
  return (
    <BrowserRouter>
      <Switch>
        <Route
          path="/grades/:gradableType/:gradableId/"
          render={props => (
            <GradingStationIndividualPageContainer
              currentUser={currentUser}
              ziggeoApiKey={ziggeoApiKey}
              {...props}
            />
          )}
        />
        <Route
          path="/grades"
          render={props => (
            <GradingStationContainer
              currentUser={currentUser}
              canGradeGroups={canGradeGroups}
              {...props}
            />
          )}
        />
      </Switch>
    </BrowserRouter>
  );
};

export default props => <GradingStationRoot {...props} />;
